import { useEffect, useState } from "react";
import {
  Box,
  Button,
  Text,
  HStack,
  Stack,
  Link
} from "@chakra-ui/react";

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie-consent");
    if (!consent) setVisible(true);
  }, []);

  const handleConsent = (accepted: boolean) => {
    localStorage.setItem("cookie-consent", accepted ? "accepted" : "rejected");
    setVisible(false);

    if (accepted) {
      console.log("Cookie accettati");
    } else {
      console.log("Cookie rifiutati");
    }
  };

  if (!visible) return null;

  return (
    <Box
      position="fixed"
      bottom="0"
      left="0"
      right="0"
      bg="white"
      color="gray.800"
      px={6}
      py={4}
      zIndex={1000}
      borderTop="1px solid #ccc"
    >
      <Stack
        direction={{ base: "column", md: "row" }}
        justify="space-between"
        align="center"
      >
        <Text fontSize="sm">
          Questo sito utilizza solo ed esclusivamente cookie tecnici e di statistica aggregata
          necessari al funzionamento, alla ottimizzazione e alla statistica. <br />
          Chiudendo questo banner, scorrendo questa pagina, cliccando su un link o proseguendo la
          navigazione acconsenti all’uso dei{" "}
          <Link href="/cookies" color="primaryPatient.500" fontWeight="semibold" textDecoration="underline">
            Cookies Policy
          </Link>.
        </Text>

        <HStack>
        <Button
  bg="primaryPatient.500"
  color="white"
  _hover={{ bg: "primaryPatient.600" }}
  size="sm"
  onClick={() => handleConsent(true)}
>
  Accetta
</Button>

<Button
  variant="outline"
  borderColor="primaryPatient.500"
  color="primaryPatient.500"
  _hover={{ bg: "primaryPatient.50" }}
  size="sm"
  onClick={() => handleConsent(false)}
>
  Rifiuta
</Button>
        </HStack>
      </Stack>
    </Box>
  );
};

export default CookieBanner;
